/* BB Bedbodem PDP - optional advice-only variant pricing; no cart mutations. */
(function () {
  'use strict';
  function init(product) {
    if (!product || product.dataset.bedbodemReady === 'true') return;
    product.dataset.bedbodemReady = 'true';
    var selects = Array.from(product.querySelectorAll('[data-bb-bedbodem-option]'));
    var jsonNode = product.querySelector('[data-bb-bedbodem-variants]');
    var priceNode = product.querySelector('[data-bb-bedbodem-price]');
    var captionNode = product.querySelector('[data-bb-bedbodem-caption]');
    var noteNode = product.querySelector('[data-bb-bedbodem-minnote]');
    var statusNode = product.querySelector('[data-bb-bedbodem-choice-status]');
    var originalPrice = priceNode ? priceNode.textContent : '';
    var originalCaption = captionNode ? captionNode.textContent : '';
    var variants = [];
    try { if (jsonNode) variants = JSON.parse(jsonNode.textContent || '[]'); } catch (e) { variants = []; }
    function format(price) {
      try {
        return new Intl.NumberFormat('nl-NL', { style:'currency', currency:'EUR', minimumFractionDigits:0, maximumFractionDigits:2 }).format(Number(price) / 100);
      } catch (e) { return originalPrice; }
    }
    function setPrice(variant, values, updateUrl) {
      var complete = values.length && values.every(function (s) { return Boolean(s); });
      if (!complete || !variant) {
        if (priceNode) priceNode.textContent = originalPrice;
        if (captionNode) captionNode.textContent = originalCaption;
        if (noteNode) noteNode.hidden = false;
        if (statusNode) statusNode.textContent = complete ? 'Deze combinatie is niet beschikbaar. Vraag ons om advies.' : 'Kies een maat om de bijbehorende prijs te zien.';
        if (updateUrl && window.history && window.URL) {
          var baseUrl = new URL(window.location.href);
          baseUrl.searchParams.delete('variant');
          window.history.replaceState(window.history.state, '', baseUrl.toString());
        }
        return;
      }
      if (priceNode) priceNode.textContent = format(variant.price);
      if (captionNode) captionNode.textContent = 'Prijs voor jouw keuze';
      if (noteNode) noteNode.hidden = true;
      if (statusNode) statusNode.textContent = variant.available ? 'Prijs voor ' + values.join(' · ') + '. Advies en bestelling bespreken we graag met je.' : 'Deze uitvoering is niet direct beschikbaar. Vraag ons naar de mogelijkheden.';
      if (updateUrl && window.history && window.URL) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }
    function currentSelection() {
      var values = [];
      selects.forEach(function (select) {
        values[Number(select.dataset.optionIndex || 0)] = select.value;
      });
      return values;
    }
    function findVariant(values) {
      return variants.find(function (variant) {
        return values.length === variant.options.length && variant.options.every(function (name, i) { return name === values[i]; });
      });
    }
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var values = currentSelection();
        setPrice(findVariant(values), values, true);
      });
    });
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (e) { params = null; }
    var chosen = params ? params.get('variant') : null;
    if (chosen && selects.length) {
      var initial = variants.find(function (v) { return String(v.id) === String(chosen); });
      if (initial) {
        selects.forEach(function (select) {
          select.value = initial.options[Number(select.dataset.optionIndex || 0)] || '';
        });
        setPrice(initial, currentSelection(), false);
      }
    }
    var sticky = document.querySelector('[data-bb-bedbodem-sticky]');
    var primary = product.querySelector('.bb-base__cta-primary');
    if (sticky && primary && 'IntersectionObserver' in window) {
      var visible = true;
      var watcher = new IntersectionObserver(function (entries) {
        visible = Boolean(entries[0] && entries[0].isIntersecting);
        updateSticky();
      }, { threshold:0.1 });
      function updateSticky() {
        var passed = primary.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', passed && !visible);
      }
      watcher.observe(primary);
      window.addEventListener('scroll', updateSticky, { passive:true });
    }
  }
  function ready() {
    document.querySelectorAll('[data-bb-bedbodem-product]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', ready);
})();